import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { AuthLocationUserState } from './auth-location-user.state';
import { AuthLocationUserStore } from './auth-location-user.store';

@Injectable({providedIn: 'root'})
export class AuthLocationUserQuery extends QueryEntity<AuthLocationUserState> {
  constructor(protected readonly store: AuthLocationUserStore) {
    super(store);
  }
}
